export default "<router-outlet></router-outlet>\n<!--app-hospitalimages></app-hospitalimages>--\n\n<app-ad></app-ad>-->\n"